import React, { useMemo, useEffect, useState } from 'react';
import { Button, PagingQuery, Justify, BubbleContent, notification } from 'tea-component';
import SearchRecent from '@/pages/intelligence/components/SearchRecent';
import '@/pages/intelligence/assets/scss/Following/index.scss';
import SelectMultipleChoice from '@/pages/intelligence/components/SelectCompoenet/MultipleChoice';
import { TOPGAMENUM } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';
import { ChartType, FormMode } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import { handleTableDefaultSelectGames } from '@/pages/intelligence/utils/tableUtils';
import {
  getFollowingShuttleFrameList,
  createCollectionFollow,
  getSearchNewList,
  getCompareEntityTypeSearch,
  followSearchPullDown,
} from '@/pages/intelligence/services/following';
import CurrentTable from './Table';
import CurrentVisualis from './VisualisCard';
import { RecordItemType } from '@/pages/intelligence/components/SearchRecent/type';
import { getCountryFlag } from '@/pages/home/_config/countries';
import Loading from '@/pages/intelligence/components/Loading';
import FollowingNoData from '@/pages/intelligence/pages/Following/components/FollowingNoData';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import {
  TableSelectStatusType,
  TableSelectionType,
} from '@/pages/intelligence/components/TableComponents/components/TableCheckbox';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { useFollowingOptionList } from '@/pages/intelligence/pages/Following/_hook/useFollowingOptionList';
import { FILTER_EXTEND_NAMESPACE } from '@/pages/intelligence/models/filterExtend';
import { useIntl, getLocale, history, useSelector } from 'umi';
import ExportTable from '@/pages/intelligence/components/ExportTable';
import {
  getDefaultGenreParams,
  isMetricDisabled,
  // handleRetentionMetrics,
  isSingleMonthGranularity,
  getTrendAdjustedStartDate,
  fetchFunctionsByEntityType,
  fetchTrendFunctionsByEntityType,
  getDeviceParams,
  getBigQueryTableParams,
  getBigQueryTrendSourceMetricParams,
  getFollowingTrendSegmentItems,
  createDataSourceMetricForValue,
  getLeftCellTitle,
  getFollowingMetricListWidth,
  getTitleFromMetric,
  getSumInfo,
  FOLLOWING_ST_RETENTION_METRIC_KEY,
  isFollowingRetentionMetricKey,
} from '@/pages/intelligence/pages/Following/_config/util';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import AddEntities from '@/pages/intelligence/pages/Following/components/AddEntities';
import AddGroup from '../Manage/AddGroup';
import RenameAddGroup from '../Manage/RenameAddGroup';
import { MANAGER_GROUP_NAME } from '@/pages/intelligence/pages/Following/_config/constant';
import { getDeviceValuesByPageId } from '@/pages/intelligence/pages/TopCharts/PCGames/_config/utils';
// import { getBigQueryMobileMetrics } from '@/pages/intelligence/pages/Following/_config/util';
import { getDbiFilterParams } from '@intelligence/utils/filterUtils';
import Filter from '@/pages/intelligence/pages/TopCharts/components/CommonFilter';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { formatRegionOptions } from '@intelligence/components/RegionSelector';
import { following } from '@intelligence/v3/constants/downloadLogPoint';
import { appendAdjustedRevenueFilter, REVENUE_SCOPE_VALUES } from '@intelligence/utils/revenueScope';
import { pageParamsFormatMap } from '@intelligence/components/Filter/util';

const updateMetricList = (defaultList: any[], fetchParams: any, marketsValus: string[]) => {
  const list = defaultList.map((item: any) => {
    const disabled = isMetricDisabled({
      dateType: fetchParams.date_type,
      startDate: fetchParams.start_date,
      endDate: fetchParams.end_date,
      markets: marketsValus,
      disableType: item?.disableType,
    });
    return {
      ...item,
      // MetricsList 的列表将转换的key作为value使用；
      value: item.key || item.value,
      disabled,
      tooltip:
        disabled && item?.disableInfo ? (
          <BubbleContent placement="bottom-start" dark>
            <span>{item?.disableInfo}</span>
          </BubbleContent>
        ) : undefined,
    };
  });
  return list;
};

const getRevenueScopeValue = (value?: string) => {
  return value || REVENUE_SCOPE_VALUES.EXCLUDING;
};

const getCurrentGamesFilterExtend = (
  entityType: string,
  filterExtend: any,
  defaultFormValue: any,
) => {
  if (!['pc', 'console'].includes(entityType)) {
    return filterExtend;
  }

  const genreFilterValue = filterExtend?.[filterKeyMap.GENRETOR];
  if (!genreFilterValue?.source || genreFilterValue.source === 'iegg') {
    return filterExtend;
  }

  return {
    ...filterExtend,
    [filterKeyMap.GENRETOR]: defaultFormValue?.[filterKeyMap.GENRETOR],
  };
};

export default function CurrentGames(props: any) {
  const {
    loading: isBasicLoading,
    entityType,
    pageLogMes,
    setIsUpdateBasicInfo,
    groupOptions,
    DEFAULT_GROUPNAME,
    setUpdateGroupList,
    filterCfg,
    filterLoading,
    hasFollowIds,
  } = props;

  const APPID = entityType === 'company' ? 'uuid' : 'id'; // 后端返回的游戏id字段
  const DEFAULTPAGESIZE = 20; // 宽表总数据条数
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const DEFAULT_FORM_VALUE = filterCfg?.defaultValue;
  const { userInfo, filterState } = useSelector((state: any) => {
    const { userInfo } = state.home;
    const filterState = state?.[FILTER_EXTEND_NAMESPACE] || {};
    return { userInfo, filterState };
  });

  const isOperate = filterState?.isOperate;
  const { filterExtend, setFilterExtend, resetFilterExtend } = useFilterExtend({});
  const currentGamesFilterExtend = getCurrentGamesFilterExtend(
    entityType,
    filterExtend,
    DEFAULT_FORM_VALUE,
  );
  let initialFilterValue = DEFAULT_FORM_VALUE;
  if (isOperate) {
    initialFilterValue = currentGamesFilterExtend;
  }
  const [filterValue, setFilterVale] = useState(initialFilterValue);
  const [loading, setLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(true);
  const [isVisualisLoading, setIsVisualisLoading] = useState(true);
  const [lineLoading, setLineLoading] = useState(false);
  const [dateType, setDateType] = useState('daily');
  const [visible, setVisible] = useState(false);
  const [addGroup, setAddGroup] = useState(false);
  const [addNewGroupName, setAddNewGroupName] = useState('');
  const [group, setGroup] = useState<any>(null);
  const [createRenameGroup, setCreateRenameGroup] = useState(false);
  const [mode, setMode] = useState<FormMode>(FormMode.Add);
  const [gameIds, setGameIds] = useState([]);

  const DEFAULT_GROUPNAME1 = useMemo(() => {
    const nameObj =
      entityType == 'company' ? MANAGER_GROUP_NAME.allcompanies : MANAGER_GROUP_NAME.allgames;
    return locale === 'zh-CN' ? nameObj.textcn : nameObj.text;
  }, [entityType, locale]);

  const { followingChartSegmentOpts, followingEchartTitle, consoleJapanSalesList, followListObj } =
    useFollowingOptionList({ dateType });
  const metricDefaultList = followListObj?.[entityType]?.defaultMetricList;
  const FlOLLOWING_METRIC_LIST = followListObj?.[entityType]?.allListChangeValue;
  const FlOLLOWING_ALLSOURCEMETRIC = followListObj?.[entityType]?.defaultMetricList;
  const FlOLLOWING_DEFAULTMETRIC = followListObj?.[entityType]?.defaultMetricValues;

  const segmentOptions = followingChartSegmentOpts[entityType];
  const [chartSegement, setChartSegement] = useState(segmentOptions?.[0]?.value || '');
  const [sortByName, setSortByName] = useState('');
  const [hasFollowData, setHasFollowData] = useState(false);
  const [groupName, setGroupName] = useState(DEFAULT_GROUPNAME);
  const [tableTotal, setTableTotal] = useState(0);
  // 宽表数据
  const [tableData, setTableData] = useState<any[]>([]);
  // echarts图表类型
  const [chartType, setChartType] = useState<ChartType>(ChartType.Bar);
  // 柱状图、饼图 数据源
  const [barOrPieData, setBarOrPieData] = useState<any[]>([]); // 折线图数据源
  const [lineData, setLineData] = useState<any[]>([]);
  const [metriceValue, setMetriceValue] = useState(FlOLLOWING_DEFAULTMETRIC);

  const [tableHeaderList, setTableHeaderList] = useState(metricDefaultList);
  const [isOpen, setIsOpen] = useState(false);
  const [marketsValus, setMarketsValues] = useState<string[]>(['global']); // 参与拿继承值

  // 宽表勾选的数据
  const [defaultSelectionGames, setDefaultSelectionGames] = useState<TableSelectionType[]>([]);
  const [tableSelection, setTableSelection] = useState<TableSelectionType[]>([]);
  const [tableListForClearSearch, setTableListForClearSearch] = useState([]);
  const [totalForClearSearch, setTotalForClearSearch] = useState(0);
  const [operatedGame, setOperatedGame] = useState(false);
  /** 用于下载 */
  const [downloadUnifiedIds, setDownloadUnifiedIds] = useState([]);
  const [isHandleReset, setIsHandleReset] = useState(false);

  const [defaultFetchParams, setDefaultFetchParams] = useState({
    metrics: FlOLLOWING_DEFAULTMETRIC, // 数据源筛选器的默认值
    source_metric: getBigQueryTableParams(FlOLLOWING_ALLSOURCEMETRIC),
    page: 1,
    page_size: DEFAULTPAGESIZE,
    // order_field: FlOLLOWING_DEFAULTMETRIC[entityType][0],
    order_source: FlOLLOWING_ALLSOURCEMETRIC?.[0]?.apiSource,
    ratio_type: 0,
    order_metric: FlOLLOWING_ALLSOURCEMETRIC?.[0]?.value,
    order: 'desc',
    date_type: 'daily',
    start_date: '',
    end_date: '',
    trace_id: [], // 相当于手游榜单的gamecode,
    search_id: '',
    region_type: 'region',
    regions: ['global'],
    entity_type: entityType === 'company' ? undefined : entityType,
    group_name: groupName,
    device:
      entityType === 'console'
        ? getDeviceValuesByPageId('DigitalRevenue') /** 设备在调接口前处理*/
        : undefined,
    revenue_scope:
      entityType === 'mobile'
        ? getRevenueScopeValue(DEFAULT_FORM_VALUE?.[filterKeyMap.REVENUE_SCOPE]?.value)
        : undefined,
    ...getDefaultGenreParams(entityType),
  });
  const [fetchParams, setFetchParams] = useState(defaultFetchParams);

  const [metricList, setMetricList] = useState(
    updateMetricList(FlOLLOWING_METRIC_LIST, fetchParams, marketsValus),
  );

  const metricsDateParams = useMemo(() => {
    const rangeTime = filterValue?.[filterKeyMap.RANGE_TIME];
    const rangeTimeApiParams =
      rangeTime?.type
        ? pageParamsFormatMap[filterKeyMap.RANGE_TIME]?.(rangeTime) || {}
        : rangeTime || {};
    return {
      date_type: rangeTimeApiParams?.granularity || fetchParams.date_type || 'daily',
      start_date: rangeTimeApiParams?.start_date || fetchParams.start_date || '',
      end_date: rangeTimeApiParams?.end_date || fetchParams.end_date || '',
    };
  }, [
    filterValue?.[filterKeyMap.RANGE_TIME],
    fetchParams.date_type,
    fetchParams.start_date,
    fetchParams.end_date,
  ]);

  const buildRequestParams = (params: any) => {
    const { revenue_scope, adjusted_revenue, ...restParams } = params || {};

    if (entityType !== 'mobile') {
      return restParams;
    }

    return appendAdjustedRevenueFilter(restParams, getRevenueScopeValue(revenue_scope), adjusted_revenue);
  };

  useEffect(() => {
    try {
      if (isBasicLoading || filterLoading) {
        setLoading(true);
      } else {
        let newFetchParams = { ...fetchParams };
        const { filterValue, filterParams } = getDbiFilterParams({
          // urlFilter: any,
          filterSaveData: {}, // filterData?.apiValue,
          filterExtend: currentGamesFilterExtend,
          specialParams: filterCfg?.specialParams,
          isOperate,
          filterName: '',
          filterKeyList: filterCfg?.filterKeyList ?? Object.keys(DEFAULT_FORM_VALUE),
        });
        /** 特殊处理一下不做继承的值：Group ,首次进来使用默认值*/
        const newFilterValue = {
          ...filterValue,
          [filterKeyMap.FOLLOWING_GLOUP]: DEFAULT_FORM_VALUE?.[filterKeyMap.FOLLOWING_GLOUP],
        };
        const newFilterParams = {
          ...filterParams,
          group_name: DEFAULT_FORM_VALUE?.[filterKeyMap.FOLLOWING_GLOUP]?.value,
        };
        if (isOperate) {
          // 如果目前是继承模式，就设置继承值为过滤后的筛选器值
          setFilterExtend(newFilterValue);
        }
        setFilterVale(newFilterValue);
        newFetchParams = {
          ...newFetchParams,
          ...filterCfg?.handleFilterToApiParams(newFilterParams),
          revenue_scope:
            entityType === 'mobile'
              ? getRevenueScopeValue(newFilterParams?.revenue_scope)
              : undefined,
        };
        // 更新dateType,feat表格标题DAU/WAU/MAU展示
        setDateType(newFetchParams.date_type);
        setHasFollowData(hasFollowIds);
        newFetchParams = {
          ...newFetchParams,
          entity_type: entityType === 'company' ? undefined : entityType,
        };

        // 继承
        if (hasFollowIds) {
          setTableLoading(true);
          setIsVisualisLoading(true);
          // 获取接口
          getGameData({
            fetchParams: newFetchParams,
            isCheckGame: false,
            isSearch: false,
            isUpdateLineChart: true,
          });
        } else {
          // 没有关注游戏，展示无数据
          setLoading(false);
        }
      }
    } catch (err) {
      setLoading(false);
    }
  }, [filterLoading, isBasicLoading, entityType, hasFollowIds /* ogdbIds, followIds*/]);

  const getSortByName = (list, params) => {
    // 如果是后端返回的不一样则重新找到对应的排序名
    const metricKey = createDataSourceMetricForValue(params?.order_metric, params?.order_source);
    const sortItem = list.find((t) => {
      return t?.key === metricKey;
    });
    return getTitleFromMetric(metricKey) + (sortItem?.title || sortItem?.text);
  };

  useEffect(() => {
    // 翻译表格
    const metrics = tableHeaderList.map((t) => {
      return t?.key;
    });
    const list = FlOLLOWING_METRIC_LIST?.filter((metric: any) => {
      return metrics.includes(metric?.key);
    });
    setTableHeaderList(list);

    setSortByName(getSortByName(list, fetchParams));
  }, [locale, dateType]);

  const getGameData = async (args: {
    fetchParams: any;
    isCheckGame: boolean;
    isSearch?: boolean;
    isUpdateLineChart: boolean;
  }) => {
    const { fetchParams, isCheckGame, isSearch = false, isUpdateLineChart = true } = args;
    const params = {
      ...fetchParams,
      search_id: isSearch ? fetchParams?.search_id : '',
      // 对device参数进行处理
      device: entityType === 'console' ? getDeviceParams(fetchParams.device) : undefined,
    };

    try {
      setTableData([]);
      setFetchParams(params);
      // 如果没有关注的游戏就不请求接口了
      if (!hasFollowIds) {
        return;
      }
      /** 更新表格列 */
      const tableCloms = FlOLLOWING_METRIC_LIST?.filter((t: any) => {
        return params?.metrics?.includes(t?.key);
      });
      setTableHeaderList(tableCloms);

      const fetchFunction = fetchFunctionsByEntityType[entityType];
      const requestParams = buildRequestParams({
        ...params,
        metrics:
          entityType === 'company'
            ? params.metrics
            : undefined /* handleRetentionMetrics(params.metrics)*/,
      });

      // 这里传参的metrics做特殊处理，不set到fetchparams中
      const resData = await fetchFunction(requestParams);

      const list = resData?.data?.table_list || [];
      const total = resData?.data?.total || 0;
      const req = resData?.req;
      let checkGameList = tableSelection;

      if (params.page === 1) {
        /** 第一页时拿到默认前6个游戏作为游戏全选值 */
        const defaultGames = handleTableDefaultSelectGames(list.slice(0, TOPGAMENUM), APPID);
        setDefaultSelectionGames(defaultGames);
        /** 在第一页且没有勾选游戏时默认选中前6（游戏在排序或重新筛选时有更新） */
        if (!isCheckGame) {
          setTableSelection(defaultGames);
          /** 分页排序请求接口时，可视化不改变 */
          const barOrPieDataTmp = list?.slice(0, TOPGAMENUM);
          setBarOrPieData(barOrPieDataTmp);

          checkGameList = defaultGames;
        }
      }
      let tableListReal = [];
      const totalNum = total || list?.length;
      // 如果是最后一页，则展示sumavg; 搜索情况不保存sumavg
      if (!isSearch && totalNum / params.page <= params.page_size) {
        const svgavg = resData?.data?.agg_list || [];
        // feat: 在Loading时操作筛选器展示多个sum, 原因：列表中的recordKey(id)为空，渲染出问题
        const hasIdSvgavgList = svgavg?.map((t) => {
          return { ...t, id: t?.agg_name };
        });
        // 当列表不为空时， 展示sumavg， 否则不展示sumavg
        tableListReal = list?.length > 0 ? [...list, ...hasIdSvgavgList] || [] : [];
      } else {
        tableListReal = list || [];
      }

      if (!params?.search_id) {
        // 有game_code表示是搜索，则不存页面数据
        setTableListForClearSearch(tableListReal || []);
        setTotalForClearSearch(totalNum);
      }
      setTableTotal(totalNum);
      setTableData(tableListReal);

      if (req) {
        // 如果数据没有正常返回则不设置
        const newFetchParams = {
          ...params,
          date_type: req?.date_type || 'daily',
          start_date: req?.start_date || '',
          end_date: req?.end_date || '',
          /** 当筛选国家数据不一样时，表格要以当前第一个有数据的排序，后端返回 */
          order_metric: req?.order_metric || params?.order_metric,
          order_source: req?.order_source || params?.order_source,
          // order_field: req?.order_field || params?.order_field,
          order: req?.order || params?.order,
          ratio_type: req?.ratio_type || params?.ratio_type,
        };
        if (params.order_metric !== req?.order_metric || !sortByName) {
          setSortByName(getSortByName(tableCloms, newFetchParams));
        }
        setFetchParams(newFetchParams);
      }

      if (
        (chartType === ChartType.Line ||
          isFollowingRetentionMetricKey(chartSegement)) &&
        isUpdateLineChart
      ) {
        if (checkGameList.length > 0) {
          const idList = checkGameList.map((t) => {
            return t?.gameId;
          });
          getLineChartData(params, idList, chartSegement);
        }
      }
    } catch (e) {
      console.error(e);
      setTableData([]);
      setBarOrPieData([]);
      setLineData([]);
      setTableSelection([]);
    } finally {
      setLoading(false);
      setIsVisualisLoading(false);
      setTableLoading(false);
    }
  };

  const onTableSortChage = async (e: SortByItemType) => {
    const isRetentionKeys = ['D2', 'D3', 'D7', 'D15', 'D31'].includes(e.sortMetric);
    const newFetchParams = {
      ...fetchParams,
      order: e?.sortVal,
      // order_field: e?.ratioType === 1 ? e?.sortMetric + ORDER_RATIO : e?.sortMetric,
      order_source: isRetentionKeys ? e?.orderSource || fetchParams?.order_source : e?.orderSource,
      ratio_type: e?.ratioType === 1 ? 1 : 0,
      order_metric: e?.sortMetric,
      page: 1,
      page_size: DEFAULTPAGESIZE,
    };

    setSortByName(
      getTitleFromMetric(createDataSourceMetricForValue(e?.sortMetric, e?.orderSource)) + e.title,
    );
    setTableLoading(true);
    if (!operatedGame) {
      /** 没有勾选时点排序则重新Loading柱状图数据 */
      setIsVisualisLoading(true);
    }
    await getGameData({
      fetchParams: newFetchParams,
      isCheckGame: operatedGame,
      isSearch: false,
      isUpdateLineChart: !operatedGame,
    });
  };

  const onTablePagingChange = (e: PagingQuery) => {
    const newFetchParams = {
      ...fetchParams,
      page: e?.pageIndex || 1,
      page_size: e?.pageSize || DEFAULTPAGESIZE,
    };
    setTableLoading(true);
    getGameData({
      fetchParams: newFetchParams,
      isCheckGame: operatedGame,
      isSearch: false,
      isUpdateLineChart: false,
    });
  };

  // 表格列表项选择事件回调
  const onTableCheckGame = (
    selectList: TableSelectionType[],
    checkStatus: TableSelectStatusType,
  ) => {
    // setIsNewComfirm(true);
    // setIsNewCheckGame(true);
    const idList = selectList.map((t) => {
      return t?.gameId;
    });
    if (chartType === ChartType.Line || isFollowingRetentionMetricKey(chartSegement)) {
      getLineChartData(fetchParams, idList, chartSegement);
    }
    /** 是否勾选了游戏 */
    if (checkStatus === 'cancel' || checkStatus === 'all' || selectList.length === 0) {
      setOperatedGame(false);
    } else {
      setOperatedGame(true);
    }
    setBarOrPieData(selectList);
    setTableSelection(selectList);
  };

  const updateMetrics = (
    currentMetrics: string[],
    metricsParams = { ...fetchParams, ...metricsDateParams },
    markets = marketsValus,
  ) => {
    const list = updateMetricList(FlOLLOWING_METRIC_LIST, metricsParams, markets);
    setMetricList(list);
    const filteredMetrics = currentMetrics.filter((metric: string) => {
      const metricObj = list.find((m) => m.key === metric);
      return !(metricObj && metricObj.disabled === true);
    });
    setMetriceValue(filteredMetrics);
    return filteredMetrics;
  };

  const shouldAutoAppendSTRetention = (
    nextFetchParams: { date_type?: string; start_date?: string; end_date?: string },
    nextMarkets: string[],
  ) => {
    if (entityType !== 'mobile' || nextFetchParams?.date_type !== 'monthly') {
      return false;
    }

    const stRetentionMetric = FlOLLOWING_METRIC_LIST?.find(
      (item: any) => item.key === FOLLOWING_ST_RETENTION_METRIC_KEY,
    );

    return (
      stRetentionMetric &&
      !isMetricDisabled({
        dateType: nextFetchParams.date_type,
        startDate: nextFetchParams.start_date,
        endDate: nextFetchParams.end_date,
        markets: nextMarkets,
        disableType: stRetentionMetric.disableType,
      })
    );
  };

  useEffect(() => {
    // 下拉列表DAU/WAU/MAU文本异步要用
    updateMetrics(metriceValue);
  }, [
    fetchParams,
    marketsValus,
    locale,
    metricsDateParams.date_type,
    metricsDateParams.start_date,
    metricsDateParams.end_date,
  ]);

  const handleConfirm = async (value: any, apiValue?: any) => {
    const markets: string[] = value?.regions;

    setMarketsValues(markets);
    const newFormValue = {
      ...fetchParams,
      ...value,
      revenue_scope:
        entityType === 'mobile'
          ? getRevenueScopeValue(apiValue?.[filterKeyMap.REVENUE_SCOPE]?.value)
          : undefined,
      page: 1,
      page_size: DEFAULTPAGESIZE,
    };
    setDateType(newFormValue.date_type);
    // confirm之后更新metric筛选器渲染(哪些要禁用)
    const filteredMetrics = updateMetrics(metriceValue, newFormValue, markets);
    const nextMetrics = [...filteredMetrics];
    if (
      shouldAutoAppendSTRetention(newFormValue, markets) &&
      !nextMetrics.includes(FOLLOWING_ST_RETENTION_METRIC_KEY)
    ) {
      nextMetrics.push(FOLLOWING_ST_RETENTION_METRIC_KEY);
    }
    const sourceArr: any = [];
    nextMetrics?.forEach((item) => {
      FlOLLOWING_METRIC_LIST?.forEach((subItem: any) => {
        if (subItem.key == item) {
          sourceArr.push(subItem);
        }
      });
    });
    const nextFetchParams = {
      ...newFormValue,
      metrics: nextMetrics,
      source_metric:
        sourceArr.length > 0 ? getBigQueryTableParams(sourceArr) : newFormValue?.source_metric,
    };
    setMetriceValue(nextMetrics);
    // 请求接口
    setTableLoading(true);
    setIsVisualisLoading(true);
    /** 修改筛选器后，游戏应该重置为未勾选状态 */
    setOperatedGame(false);
    await getGameData({
      fetchParams: nextFetchParams,
      isCheckGame: false,
      isSearch: false,
      isUpdateLineChart: true,
    });

    // setIsNewComfirm(true);
    // setIsNewCheckGame(true);
  };

  const handleClearSearch = () => {
    setFetchParams({ ...fetchParams, trace_id: [] });
    setTableData(tableListForClearSearch);
    setTableTotal(totalForClearSearch);
  };

  const getTableSearchList = (id: string) => {
    setTableLoading(true);
    getGameData({
      fetchParams: { ...fetchParams, search_id: id },
      isCheckGame: true,
      isSearch: true,
      isUpdateLineChart: false,
    });
  };

  const transTableDataForSearch = (res: any) => {
    const resultList = res?.data?.table_list;
    if (!Array.isArray(resultList) || !resultList?.length) {
      return [];
    }
    const tranksList: RecordItemType[] = resultList.map((item) => {
      return {
        id: item?.[APPID],
        imgSrc: item?.cover,
        lineOneStr: item?.name,
        lineTwoImg: getCountryFlag(
          entityType === 'pc' || entityType === 'console'
            ? item?.publisher_addr
            : item?.markets,
        ),
        lineTwoImgName:
          entityType === 'pc' || entityType === 'console'
            ? item?.publisher_addr
            : item?.markets,
        // imageType: '',
        lineTwoStr: item?.publisher,
      };
    });
    return tranksList;
  };

  const getLineChartData = async (
    params: any,
    idList: string[],
    chartSegement: string /** 折线图每次请求一个指标 */,
  ) => {
    if (idList?.length > 0) {
      if (!params.start_date || !params.end_date || !chartSegement) {
        return;
      }
      const segmentItem = getFollowingTrendSegmentItems(
        chartSegement,
        FlOLLOWING_METRIC_LIST,
        params?.metrics || fetchParams?.metrics || [],
      );
      setIsVisualisLoading(true);
      setLineLoading(true);
      try {
        const newFetchParams = {
          // ...params,
          entity_type: entityType,
          //   metrics:[
          //     "appannie_au",
          //     "sensortower_au",
          //     createDataSourceMetricForValue(segmentItem[0]?.metric, segmentItem[0]?.apiSource)
          // ],//TODO 删掉
          // metrics: metrics, //FlOLLOWING_TRENDMEMTRICS[entityType], //数据源筛选器的默认值
          metrics: entityType === 'company' ? [chartSegement] : undefined,
          data_method: 'date',
          date_type: params.date_type,
          start_date: getTrendAdjustedStartDate(params.date_type, params.start_date, params.end_date),
          end_date: params.end_date,
          region_type: params.region_type,
          regions: params.regions,
          trace_id: idList,
          source_metric:
            entityType === 'mobile'
              ? getBigQueryTrendSourceMetricParams(segmentItem)
              : getBigQueryTableParams(segmentItem),
          revenue_scope: params?.revenue_scope,
        } as any;

        const fetchTrendFunction = fetchTrendFunctionsByEntityType[entityType];
        const resData = await fetchTrendFunction(buildRequestParams(newFetchParams));
        setLineData(resData?.data?.time_lines || []);
        // setIsNewComfirm(false);
        // setIsNewCheckGame(false);
      } catch (e) {
        console.error(e);
      } finally {
        setIsVisualisLoading(false);
        setLineLoading(false);
      }
    } else {
      // 未勾选任何游戏，不请求，返回为空数据
      setLineData([]);
    }
  };
  // 切换charts类型事件
  const handleChartType = (value: ChartType) => {
    if (
      value === ChartType.Line &&
      tableSelection?.length /* &&//TODO 检查这块代码无勾选是什么情况
      isNewComfirm &&
      isNewCheckGame*/
    ) {
      const idList = tableSelection.map((t) => {
        return t?.gameId;
      });
      getLineChartData(fetchParams, idList, chartSegement);
    }
    setChartType(value);
  };

  // 切换charts类型事件
  const handleSegementVal = (
    segmentVal: string,
    chartType: ChartType,
    skipFetch = false,
  ) => {
    if (
      !skipFetch &&
      chartType === ChartType.Line &&
      tableSelection?.length /* &&//TODO 检查这块代码无勾选是什么情况
      isNewComfirm &&
      isNewCheckGame*/
    ) {
      const idList = tableSelection.map((t) => {
        return t?.gameId;
      });
      getLineChartData(fetchParams, idList, segmentVal);
    }
    setChartType(chartType);
    setChartSegement(segmentVal);
  };

  const cardSlotTitle = (
    <>
      <span style={{ marginRight: 8 }}>{followingEchartTitle[entityType]}</span>
      {entityType === 'mobile' && (
        <TipContext
          AWidth={600}
          tipText={formatMessage({
            id: `dbi_info_following_mobile_title`,
          })}
        />
      )}
    </>
  );

  const onClickNodata = async () => {
    resetFilterExtend();
    const newFetchParams = {
      ...defaultFetchParams,
    };
    setIsHandleReset(true);
    setTableLoading(true);
    setIsVisualisLoading(true);
    /** 修改筛选器后，游戏应该重置为未勾选状态 */
    setOperatedGame(false);
    await getGameData({
      fetchParams: newFetchParams,
      isCheckGame: false,
      isSearch: false,
      isUpdateLineChart: true,
    });
    setIsHandleReset(false);
  };

  // 只重置国家筛选器
  const onClickStreamingNodata = async () => {
    setFilterVale({
      ...filterValue,
      [filterKeyMap.REGION]: {
        regions: [],
        markets: ['global'],
        type: 'market',
      },
      [filterKeyMap.COMPOSED_COUNTRY_SELECT]: {},
    });
    setFilterExtend({
      ...filterExtend,
      [filterKeyMap.REGION]: {
        regions: [],
        markets: ['global'],
        type: 'market',
      },
      [filterKeyMap.COMPOSED_COUNTRY_SELECT]: {},
    });
    const newFetchParams = {
      ...fetchParams,
      regions: ['global'],
    };
    setTableLoading(true);
    setIsVisualisLoading(true);
    await getGameData({
      fetchParams: newFetchParams,
      isCheckGame: false,
      isSearch: false,
      isUpdateLineChart: true,
    });
  };

  const handleFollowConfirm = async (checkedList: any) => {
    const params = {
      game_company_ids: checkedList,
      entity_type: entityType,
      group_name: [DEFAULT_GROUPNAME],
      user_id: userInfo?.userid,
    };
    setGameIds(checkedList);
    try {
      // TO DO 调用保存的接口
      const res = await createCollectionFollow(params);
      setVisible(false);
      setUpdateGroupList(true);
      // 更新BasicInfo
      setIsUpdateBasicInfo(true);
      const newFetchParams = {
        ...defaultFetchParams,
      };
      await getGameData({
        fetchParams: newFetchParams,
        isCheckGame: false,
        isSearch: false,
        isUpdateLineChart: true,
      });
      const { destroy } = notification.success({
        unique: true,
        description: (
          <div>
            <span>{formatMessage({ id: 'dbi_success_follow' })}</span>
            <span
              style={{ color: '#326FF0', cursor: 'pointer', marginLeft: 10 }}
              onClick={() => handleAddToGroup(destroy)}
            >
              {formatMessage({ id: 'dbi_add_to_group' })}
            </span>
          </div>
        ),
      });
    } catch (error) {
      notification.error({
        unique: true,
        description: formatMessage({ id: 'dbi_failed_follow' }),
      });
    }
  };

  const handleAddToGroup = (destroy) => {
    destroy?.();
    // 若默认分组只有All Games，在提示点击Add to a Group后弹出Create a New Group弹窗
    if (groupOptions.length === 1 && groupOptions[0]?.value === DEFAULT_GROUPNAME) {
      setCreateRenameGroup(true);
    } else {
      setAddGroup(true);
    }
  };

  const handleAddGroupClose = () => {
    setAddGroup(false);
  };

  const handleChangeSeg = (value) => {
    // 更新Follow接口
    setUpdateGroupList(true);
    // 打开Add to a Group弹窗并选择创建的分组 TODO
    setAddGroup(true);
  };

  const allGameTotal = useMemo(() => {
    const group = groupOptions.find((item) => item.value === DEFAULT_GROUPNAME);
    return group?.game_list_total || 0;
  }, [groupOptions]);

  const countriesCodes = formatRegionOptions(filterCfg?.specialParams?.regionOptions)?.countryCode;

  return (
    <>
      <div className="dbi-following-page-filter">
        <Filter
          timeFilterValues={{
            type: fetchParams.date_type,
            value: [fetchParams.start_date, fetchParams.end_date],
          }}
          filterConfirm={handleConfirm}
          filterReset={() => {}}
          isHandleReset={isHandleReset}
          filterValue={filterValue}
          setFilterVale={setFilterVale}
          defaultValue={DEFAULT_FORM_VALUE}
          filterCfg={filterCfg}
        />
      </div>
      {loading ? (
        <CardSlotV2 iconList={[]} title={cardSlotTitle}>
          <div style={{ height: 250 }}>
            <Loading />
          </div>
        </CardSlotV2>
      ) : !hasFollowData ? (
        <CardSlotV2 iconList={[]} title={cardSlotTitle}>
          <FollowingNoData
            noFollowData={!hasFollowData}
            entityType={entityType}
            isNewGame={false}
            setVisible={setVisible}
          />
        </CardSlotV2>
      ) : (
        <>
          <CurrentVisualis
            APPID={APPID}
            fetchParams={fetchParams}
            barOrPieData={barOrPieData}
            lineData={lineData}
            metriceValue={fetchParams.metrics}
            entityType={entityType}
            handleChartType={handleChartType}
            handleSegementVal={handleSegementVal}
            isSingleMonth={isSingleMonthGranularity(
              metricsDateParams.date_type,
              metricsDateParams.start_date,
              metricsDateParams.end_date,
            )}
            isVisualisLoading={
              isVisualisLoading || loading || (chartType === ChartType.Line && lineLoading)
            }
            dateType={metricsDateParams.date_type}
            sortByName={sortByName}
            cardSlotTitle={cardSlotTitle}
            segmentAllOptions={segmentOptions}
            onClickNodata={onClickStreamingNodata}
            // 当与全量国家数量相等或为global时，则是global
            isGlobal={
              countriesCodes?.length === fetchParams?.regions?.length ||
              fetchParams?.regions?.[0] === 'global'
            }
          />
          <Justify
            className="dbi-following-justify"
            left={
              // //1 勾选的数据对应表格展示，并按顺序展示
              // //勾选的如果是retention, 则它对应的表格值为 'D2', 'D3', 'D7', 'D15', 'D31' 5个指标传
              <SelectMultipleChoice
                className="games-search-item "
                overlayClassName="following-metric-overlay"
                optionsList={metricList}
                changeValue={metriceValue}
                listHeight={285}
                listWidth={getFollowingMetricListWidth(entityType, locale)}
                labelValue={formatMessage({ id: 'dbi_top_metric' })}
                total={true}
                getSelectMultiple={(value: any) => {
                  setMetriceValue(value);
                }}
                onClose={() => {
                  /** 勾选的值会成为新的列表表头项，也会对可视化的指标进行禁用联动 */
                  const defaultMetricValues = FlOLLOWING_DEFAULTMETRIC;
                  const values =
                    !Array.isArray(metriceValue) || metriceValue?.length === 0
                      ? defaultMetricValues
                      : metriceValue;
                  try {
                    if (JSON.stringify(values) === JSON.stringify(fetchParams.metrics)) {
                      return;
                    }
                  } catch (err) {
                    console.log(err);
                  }

                  setMetriceValue(values);
                  setTableLoading(true);
                  setIsVisualisLoading(true);
                  const paramsMetrics = values;
                  // metrics参数不需要了，只有company需要
                  // let indexPrice = paramsMetrics.indexOf('vginsights_est_price');
                  // let indexPriceTime = paramsMetrics.indexOf('vginsights_est_price_time');
                  // //如果是勾选了SteamPrice，则传折线参数
                  // if (indexPrice !== -1 && indexPriceTime === -1) {
                  //   paramsMetrics.push('vginsights_est_price_time');
                  // }
                  // //如果是取消勾选SteamPrice，则删除折线参数
                  // if (indexPrice === -1 && indexPriceTime !== -1) {
                  //   paramsMetrics.splice(indexPriceTime, 1);
                  // }

                  let newFetchParams = {
                    ...fetchParams,
                    metrics: paramsMetrics,
                    order_metric: isFollowingRetentionMetricKey(values?.[0])
                      ? 'D2'
                      : values?.[0],
                    // order_field: values?.[0] === 'retention' ? 'D2' : values?.[0],
                  };

                  const sourceArr: any = [];
                  values?.forEach((item) => {
                    FlOLLOWING_METRIC_LIST?.forEach((subItem: any) => {
                      if (subItem.key == item) {
                        sourceArr.push(subItem);
                      }
                    });
                  });

                  if (sourceArr?.length > 0) {
                    newFetchParams = {
                      ...newFetchParams,
                      source_metric: getBigQueryTableParams(sourceArr),
                      order_source: sourceArr[0].apiSource,
                      ratio_type: 0,
                      order_metric: sourceArr[0].value === 'retention' ? 'D2' : sourceArr[0].value,
                    };
                  }
                  /** 这里需要提前设置fetchparams值，不然可视的禁用逻辑要等表格请求完 */
                  setFetchParams(newFetchParams);
                  getGameData({
                    fetchParams: newFetchParams,
                    isCheckGame: false,
                    isSearch: false,
                    isUpdateLineChart: true,
                  });
                }}
              />
            }
            right={
              <>
                <SearchRecent
                  fetchParams={buildRequestParams({ ...fetchParams, page: 1 })}
                  handleClear={handleClearSearch}
                  getTableResultList={getTableSearchList}
                  searchListApi={fetchFunctionsByEntityType[entityType]}
                  pageLogInfo={pageLogMes}
                  searchType={`follow_${entityType}_old`}
                  transTableDataForSearch={transTableDataForSearch}
                  initSearchInput={!(fetchParams?.search_id?.length > 0)}
                />

                {entityType === 'mobile' ? (
                  <ExportTable
                    classModalName="dbi-following-download"
                    downloadModalSize={820}
                    entityType={entityType}
                    businessType={'following-currentgame-mobile'}
                    isDisableDownload={tableLoading}
                    total={tableTotal}
                    downloadLogConfigKey={following?.[`${entityType}_current`]}
                    tableParams={{
                      ...fetchParams,
                      // markets: mobileMakets,
                      is_following: true,
                      marketsValus,
                      metricList: FlOLLOWING_METRIC_LIST,
                      entity_type: entityType,
                    }}
                  />
                ) : (
                  <ExportTable
                    classModalName="dbi-following-download"
                    downloadModalSize={820}
                    entityType={entityType}
                    businessType={
                      entityType === 'company' ? 'following-newcompany' : 'following-currentgame'
                    }
                    downloadLogConfigKey={following?.[`${entityType}_current`]}
                    isDisableDownload={tableLoading}
                    total={tableTotal}
                    tableParams={{
                      ...fetchParams,
                      metrics: tableHeaderList?.length
                        ? tableHeaderList
                          .map((t: any) => t?.key)
                          .filter((k: any) => fetchParams?.metrics?.includes(k))
                        : fetchParams?.metrics,
                      // 让下载请求中的 order_metrics 顺序与表格列顺序一致
                      order_metrics: tableHeaderList?.length
                        ? tableHeaderList.map((t: any) => ({
                          dataSource: t?.apiSource,
                          metric: t?.value,
                        }))
                        : undefined,
                      unifiedIds: downloadUnifiedIds,
                      is_following: true,
                      marketsValus,
                      metricList,
                      disabledMetricList: consoleJapanSalesList,
                    }}
                  />
                )}
              </>
            }
          />
          <CardSlotV2>
            <CurrentTable
              APPID={APPID}
              entityType={entityType}
              loading={tableLoading || loading}
              tableTotal={tableTotal}
              records={tableData}
              tableSelection={tableSelection}
              tableSelectionAll={defaultSelectionGames}
              pageSortAttr={{
                tablePageIndex: fetchParams?.page,
                tablePageSize: fetchParams?.page_size,
                currentSortValue: fetchParams?.order,
                currentSortMetric: createDataSourceMetricForValue(
                  fetchParams?.order_metric,
                  fetchParams?.order_source,
                ),
                currentRatioType: fetchParams?.ratio_type,
              }}
              onTableSortChage={onTableSortChage}
              onTablePagingChange={onTablePagingChange}
              onTableCheckGame={onTableCheckGame}
              tableHeaderList={tableHeaderList}
              chartSegement={chartSegement}
              onClickNodata={onClickNodata}
              dateType={fetchParams.date_type}
              sumInfo={getSumInfo(entityType, formatMessage)}
              genreSource={fetchParams?.genre_source}
            />
          </CardSlotV2>
        </>
      )}
      <AddEntities
        entityKey="gameId"
        visible={visible}
        title={formatMessage({
          id: entityType === 'company' ? 'dbi_follow_new_companies' : 'dbi_follow_new_games',
        })}
        onConfirm={handleFollowConfirm}
        entities={{
          game_type: entityType,
          user_id: userInfo?.userid,
        }}
        pleaseSelectTips={formatMessage({
          id: entityType === 'company' ? 'dbi_please_a_select_company' : 'dbi_please_a_select_game',
        })}
        searchPlaceholder={formatMessage({
          id: entityType === 'company' ? 'dbi_search_any_company' : 'dbi_search_any_game',
        })}
        rightCellTitle={formatMessage({
          id: entityType === 'company' ? 'dbi_company_companies' : 'dbi_games',
        })}
        entityType={entityType}
        getSearchNewList={getSearchNewList}
        leftCellTitle={formatMessage({
          id: allGameTotal > 0 ? 'dbi_compare_similar_games' : getLeftCellTitle(entityType),
        })}
        keywordsFetcher={followSearchPullDown}
        entitiesFetcher={getCompareEntityTypeSearch}
        similarEntitiesFetcher={getFollowingShuttleFrameList}
        onClose={() => setVisible(false)}
      />
      <AddGroup
        visible={addGroup}
        close={handleAddGroupClose}
        entityType={entityType}
        addNewGroupName={addNewGroupName}
        isMoveadd={true}
        userInfo={userInfo}
        gameIds={gameIds}
        setUpdateGroupList={setUpdateGroupList}
        setAddGroup={setAddGroup}
        groupOptions={groupOptions.filter((item) => item?.value !== DEFAULT_GROUPNAME)}
        DEFAULT_GROUPNAME={`${DEFAULT_GROUPNAME1} (${allGameTotal})`}
        getCreateGroup={() => {
          setAddGroup(false);
          setMode(FormMode.Add);
          setGroup(null);
          setCreateRenameGroup(true);
        }}
      />
      <RenameAddGroup
        visible={createRenameGroup}
        onConfirm={handleChangeSeg}
        mainSegment={entityType}
        mode={mode}
        setAddNewGroupName={setAddNewGroupName}
        groupNames={groupOptions.map((item) => item.value)}
        setCreateRenameGroup={setCreateRenameGroup}
      />
    </>
  );
}
